import axios from 'axios';

export default axios.create({
    baseURL: "https://gemngapi.augurlabs.com/api/v1",
    // baseURL: 'http://127.0.0.1:9000/api/v1',
    timeout: 50000,
    headers: {
    }
});
